import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatAbbreviatedNumber, formatNumber, isGermanLanguage } from '../../utils/language';
import {
  AmbassadorsPill,
  AmbassadorsHeading,
  AmbassadorsHeadingEmphasis,
  AmbassadorsStat1,
  AmbassadorsStat2,
  Ambassador1Name,
  Ambassador1Title,
  Ambassador1Desc,
  Ambassador2Name,
  Ambassador2Title,
  Ambassador2Desc,
  Ambassador3Name,
  Ambassador3Title,
  Ambassador3Desc,
  Ambassador4Name,
  Ambassador4Title,
  Ambassador4Desc,
} from '../../Constants';
import FabienneImg from '../../assets/testimonials/Fabienne_Ambassador.webp';
import VanessaImg from '../../assets/testimonials/Vanessa_Ambassador.webp';
import LarissaImg from '../../assets/testimonials/Larissa_Ambassador.webp';
import ValeriaImg from '../../assets/testimonials/Valerio_Ambassador.webp';

const PersonalFormulasSection = ({ rating = '4.88' }) => {
  const { t, i18n } = useTranslation();

  const ambassadors = [
    { img: FabienneImg, name: t(Ambassador1Name), title: t(Ambassador1Title), desc: t(Ambassador1Desc) },
    { img: VanessaImg, name: t(Ambassador2Name), title: t(Ambassador2Title), desc: t(Ambassador2Desc) },
    { img: LarissaImg, name: t(Ambassador3Name), title: t(Ambassador3Title), desc: t(Ambassador3Desc) },
    { img: ValeriaImg, name: t(Ambassador4Name), title: t(Ambassador4Title), desc: t(Ambassador4Desc) },
  ];

  return (
    <section className="t-w-full t-bg-navy t-py-12 md:t-py-16 t-px-4 t-flex t-flex-col t-items-center t-gap-8 md:t-gap-10">

      {/* Header */}
      <div className="t-text-center t-max-w-2xl t-flex t-flex-col t-items-center t-gap-4">
        <span className="t-font-sans t-text-[10px] t-font-semibold t-uppercase t-tracking-widest t-text-white/40">
          {t(AmbassadorsPill)}
        </span>

        <h2 className="t-font-serif t-font-normal t-text-white t-text-[26px] md:t-text-[36px] t-leading-snug !t-m-0">
          {t(AmbassadorsHeading)}{' '}
          <em className="t-text-butter">{t(AmbassadorsHeadingEmphasis)}</em>
        </h2>
      </div>

      {/* Ambassador cards — horizontal scroll on all sizes, centered on desktop */}
      <div className="t-w-full t-max-w-[1300px]">
        <div className="t-flex t-gap-5 t-overflow-x-auto hide-scrollbar t-pb-2">
          {ambassadors.map((amb, idx) => (
            <article
              key={idx}
              className="t-flex-none t-w-[272px] md:t-w-[310px] t-flex t-flex-col t-rounded-2xl t-overflow-hidden"
              style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.10)' }}
            >
              <img
                src={amb.img}
                alt={amb.name}
                className="t-w-full t-h-72 t-object-cover t-object-top"
              />
              <div className="t-px-5 t-py-5 t-flex t-flex-col t-gap-2">
                <h3 className="t-font-sans t-font-bold t-text-white t-text-base !t-m-0 t-leading-tight">
                  {amb.name}
                </h3>
                <p className="t-font-sans t-text-[10px] t-font-bold t-uppercase t-tracking-widest t-text-butter/75 !t-m-0">
                  {amb.title}
                </p>
                <p className="t-font-sans t-text-sm t-text-white/65 t-leading-relaxed !t-m-0 t-mt-2 t-italic">
                  {amb.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* Proof stat bar */}
      <div
        className="t-w-full t-max-w-[520px] t-flex t-items-center t-justify-around t-pt-6"
        style={{ borderTop: '1px solid rgba(255,255,255,0.12)' }}
      >
        <div className="t-text-center">
          <p className="!t-m-0 t-font-sans t-text-[28px] md:t-text-[32px] t-font-bold t-text-white t-leading-none">
            {isGermanLanguage(i18n.language)
              ? formatNumber(300000, i18n.language)
              : formatAbbreviatedNumber(300000, i18n.language)}+
          </p>
          <p className="!t-m-0 t-font-sans t-text-[11px] t-uppercase t-tracking-widest t-text-white/45 t-mt-1.5">
            {t(AmbassadorsStat1)}
          </p>
        </div>

        <div className="t-w-px t-h-12" style={{ background: 'rgba(255,255,255,0.15)' }} />

        <div className="t-text-center">
          <p className="!t-m-0 t-font-sans t-text-[28px] md:t-text-[32px] t-font-bold t-text-white t-leading-none">
            {isGermanLanguage(i18n.language)
              ? formatNumber(Number(String(rating).replace(',', '.')), i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : rating}/5{' '}
            <span className="t-text-butter t-text-xl">★</span>
          </p>
          <p className="!t-m-0 t-font-sans t-text-[11px] t-uppercase t-tracking-widest t-text-white/45 t-mt-1.5">
            {t(AmbassadorsStat2)}
          </p>
        </div>
      </div>

    </section>
  );
};

export default PersonalFormulasSection;
